import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaService } from '../../_services/lista.service';
import { ProcesoProductivo } from '../../_models/proceso-productivo';
import { ProcesoProductivoService } from '../../_services/proceso-productivo.service';

@Component( {
  selector: 'app-proceso-productivo-listado',
  templateUrl: 'proceso-productivo-listado.component.html'
} )

export class ProcesoProductivoListadoComponent implements OnInit {

  lisProcesoProductivo: ProcesoProductivo[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private router: Router,
               private lisServicio: ListaService,
               private autServicio: AutenticacionService,
               private serProcesoProductivo: ProcesoProductivoService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/proceso-productivo' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.LBL_PROSPROD' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'proceso-productivo-listado.component' );

    this.serProcesoProductivo.listado().subscribe( prosProd => {
      this.lisProcesoProductivo = prosProd;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

  }

  crear() {
    this.router.navigate( [ 'apl/proceso-productivo/agregar' ] );
  }

  visualizar( registro: ProcesoProductivo ) {
    this.router.navigate( [ 'apl/proceso-productivo/detalle/' + registro.idProcesoProductivo ] );
  }

  editar( registro: ProcesoProductivo ) {
    this.router.navigate( [ 'apl/proceso-productivo/actualizar/' + registro.idProcesoProductivo ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'proceso-productivo-listado.component', this.busqueda );
  }
}
